import { IRecord, IRecordType } from 'annotation-tools/utils';

// immutable object generator
export const IDownloadLink = IRecord<DownloadLinkType>({
  url: ''
});

// immutable type
export type IDownloadLinkType = IRecordType<DownloadLinkType>;

export type DownloadLinkType = {
  url: string;
};
